import { useState } from "react"
import DownloadMarketButtons from "components/Shared/Common/DownloadMarketButtons"
import CountrySelector from "components/Shared/HeaderFilters/AssociatedCountriesSelector"

export default function CommoditiesBasket() {
  const [adm0code, setAdm0code] = useState<number | undefined>(undefined)

  return (
    <div className="relative">
      <div className="space-y-5">
        <div>
          <CountrySelector allowAll={false} label="Country" onSelect={country => setAdm0code(country?.value)} />
          <DownloadMarketButtons adm0Code={adm0code} hide={["englishMarket", "localMarket"]} />
        </div>
      </div>
    </div>
  )
}
